import * as React from "react";

function SvgPencil(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 23.95 23.95"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M22.26 1.69C20.3-.28 18.83 0 18.83 0l-8.24 8.25-9.22 9.22L0 24l6.48-1.38 9.22-9.21 8.23-8.24s.3-1.52-1.67-3.48zM6.1 21.8l-2.21.47A5.2 5.2 0 003 21a5.2 5.2 0 00-1.27-.94l.48-2.21.63-.63a4.1 4.1 0 012.51 1.38 4.15 4.15 0 011.39 2.56z" />
    </svg>
  );
}

const MemoSvgPencil = React.memo(SvgPencil);
export default MemoSvgPencil;
